<template>
  <Contact class="contact-page" />
</template>

<script>
import Contact from "@/components/Contact.vue";

export default {
  components: {
    Contact
  }
};
</script>
